<template>
    <div class="notification-item" :class="{ 'read': notification.read_at }" @click="handleClick">
        <div class="notification-icon-container">
            <div class="notification-type-icon" :class="notification.type">
                <!-- Icône selon le type -->
                <template v-if="notification.type === 'new_sale'">
                    <i class="fas fa-shopping-cart" style="width: 16px; height: 16px;"></i>
                </template>
                <template v-else-if="notification.type === 'low_stock'">
                    <i class="fas fa-exclamation-triangle" style="width: 16px; height: 16px;"></i>
                </template>
                <template v-else-if="notification.type === 'payment_received'">
                    <i class="fas fa-dollar-sign" style="width: 16px; height: 16px;"></i>
                </template>
                <template v-else-if="notification.type === 'refund'">
                    <i class="fas fa-sync" style="width: 16px; height: 16px;"></i>
                </template>
                <template v-else-if="notification.type === 'new_customer'">
                    <i class="fas fa-user" style="width: 16px; height: 16px;"></i>
                </template>
                <template v-else>
                    <i class="fas fa-circle-info" style="width: 16px; height: 16px;"></i>
                </template>
            </div>
        </div>

        <div class="notification-content">
            <div class="notification-message">{{ notification.message }}</div>
            <div class="notification-time">{{ formatDate(notification.created_at) }}</div>
        </div>

        <BaseButton v-if="showActions" class="notification-action" @click.stop="markAsRead">
            <i class="fas fa-check" style="width: 16px; height: 16px;"></i>
        </BaseButton>
    </div>
</template>

<script>
export default {
    name: 'NotificationItem',
    props: {
        notification: {
            type: Object,
            required: true
        },
        showActions: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return '';

            const date = new Date(dateString);
            const now = new Date();
            const diffMs = now - date;
            const diffMins = Math.round(diffMs / 60000);
            const diffHours = Math.round(diffMs / 3600000);
            const diffDays = Math.round(diffMs / 86400000);

            // Moins d'une heure
            if (diffMins < 60) {
                return `Il y a ${diffMins} minute${diffMins > 1 ? 's' : ''}`;
            }

            // Moins d'un jour
            if (diffHours < 24) {
                return `Il y a ${diffHours} heure${diffHours > 1 ? 's' : ''}`;
            }

            // Moins d'une semaine
            if (diffDays < 7) {
                return `Il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`;
            }

            // Format standard pour les dates plus anciennes
            return date.toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });
        },
        handleClick() {
            if (!this.notification.read_at) {
                this.markAsRead();
            }
            this.$emit('click', this.notification);
        },
        markAsRead() {
            if (!this.notification.read_at) {
                this.$emit('mark-as-read', this.notification);
            }
        }
    }
}
</script>

<style scoped>
.notification-item {
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    transition: background-color 0.2s;
    position: relative;
}

.notification-item:last-child {
    border-bottom: none;
}

.notification-item:hover {
    background-color: #f9f9f9;
}

.notification-item.read {
    opacity: 0.7;
    background-color: #f5f5f5;
}

.notification-icon-container {
    margin-right: 12px;
    margin-top: 2px;
}

.notification-type-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e3f2fd;
    color: #1976d2;
}

.notification-type-icon.new_sale {
    background-color: #e8f5e9;
    color: #0A5C6B;
}

.notification-type-icon.low_stock {
    background-color: #fff8e1;
    color: #ffa000;
}

.notification-type-icon.payment_received {
    background-color: #e0f7fa;
    color: #00acc1;
}

.notification-type-icon.refund {
    background-color: #ffebee;
    color: #e53935;
}

.notification-type-icon.new_customer {
    background-color: #f3e5f5;
    color: #8e24aa;
}

.notification-content {
    flex: 1;
}

.notification-message {
    font-size: 0.85rem;
    color: #2c3e50;
    margin-bottom: 4px;
    line-height: 1.3;
}

.notification-time {
    font-size: 0.75rem;
    color: #666;
    margin-bottom: 4px;
}

.notification-action {
    background: none;
    border: none;
    color: #0A5C6B;
    padding: 4px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
    transition: opacity 0.2s ease, background-color 0.2s ease;
}

.notification-item:hover .notification-action {
    opacity: 1;
} 
</style>